/** Human-readable labels for the 12 default field paths. Consumers may
 * override/extend via `useReportTableColumns`'s `fieldLabels` option. */
export const DEFAULT_FIELD_LABELS: Record<string, string> = {
	'task.project.info': 'Project',
	'task.phase.name': 'Phase',
	'task.status.name': 'Status',
	'task.companyTaskId': 'Task ID',
	'task.name': 'Task',
	'task.assignees.firstName': 'Assignee',
	'task.work.estimate': 'Estimate',
	'task.reported.time': 'Reported time',
	'task.work.remaining': 'Remaining',
	'task.dates.start': 'Start date',
	'task.dates.deadline': 'Deadline',
	'task.role.info': 'Role',
};
